import React, { useState } from "react";
import "@/App.css";
import { PlayerProvider, usePlayer } from "./context/PlayerContext";
import MainMenu from "./screens/MainMenu";
import GameScreen from "./screens/GameScreen";
import Results from "./screens/Results";
import Garage from "./screens/Garage";
import Shop from "./screens/Shop";
import Missions from "./screens/Missions";
import DailyRewards from "./screens/DailyRewards";
import Settings from "./screens/Settings";
import Achievements from "./screens/Achievements";
import Casino from "./screens/Casino";
import Salvage from "./screens/Salvage";
import BattlePass from "./screens/BattlePass";
import AuthModal from "./screens/AuthModal";
import PaymentResult from "./screens/PaymentResult";
import AdHost from "./components/AdHost";
import { Toaster } from "sonner";

function Shell() {
  const { profile, ready, error } = usePlayer();
  const path = typeof window !== "undefined" ? window.location.pathname : "/";
  const [view, setView] = useState("menu"); // menu | game | results
  const [panel, setPanel] = useState(null);
  const [results, setResults] = useState(null);
  const [matchKey, setMatchKey] = useState(0);
  const [mode, setMode] = useState("solo");
  const [partyCode, setPartyCode] = useState(null);

  if (path.startsWith("/payment/success")) return <PaymentResult kind="success" />;
  if (path.startsWith("/payment/cancel")) return <PaymentResult kind="cancel" />;

  if (!ready || !profile) {
    return (
      <div className="arena-bg grain fixed inset-0 flex flex-col items-center justify-center gap-4" data-testid="loading-screen">
        <h1 className="font-head font-black text-5xl sm:text-6xl uppercase tracking-tighter">
          <span className="text-white">SMASH</span><span className="text-amber-500">UP</span><span className="text-cyan-400">.io</span>
        </h1>
        {error ? <div className="text-red-400 text-sm max-w-xs text-center" data-testid="boot-error">{error}</div>
          : <div className="text-slate-400 animate-pulse">Warming up the engines...</div>}
      </div>
    );
  }

  const startMatch = (m = "solo", opts = {}) => { setMode(m); setPartyCode(opts.code || null); setMatchKey((k) => k + 1); setView("game"); };

  return (
    <>
      {view === "menu" && <MainMenu onPlay={startMatch} onPanel={setPanel} />}
      {view === "game" && (
        <GameScreen
          key={matchKey}
          profile={profile}
          mode={mode}
          partyCode={partyCode}
          onMatchEnd={(r) => { setResults(r); setView("results"); }}
          onQuit={() => setView("menu")}
        />
      )}
      {view === "results" && results && (
        <Results
          results={results}
          onPlayAgain={() => startMatch(mode)}
          onMenu={() => setView("menu")}
        />
      )}

      {panel === "garage" && <Garage onClose={() => setPanel(null)} onNeedShop={() => setPanel("shop")} />}
      {panel === "shop" && <Shop onClose={() => setPanel(null)} />}
      {panel === "missions" && <Missions onClose={() => setPanel(null)} />}
      {panel === "daily" && <DailyRewards onClose={() => setPanel(null)} />}
      {panel === "settings" && <Settings onClose={() => setPanel(null)} onAuth={() => setPanel("auth")} />}
      {panel === "achievements" && <Achievements onClose={() => setPanel(null)} />}
      {panel === "casino" && <Casino onClose={() => setPanel(null)} onBuyCoins={() => setPanel("shop")} />}
      {panel === "salvage" && <Salvage onClose={() => setPanel(null)} onNeedShop={() => setPanel("shop")} />}
      {panel === "battlepass" && <BattlePass onClose={() => setPanel(null)} />}
      {panel === "auth" && <AuthModal onClose={() => setPanel(null)} />}
      <AdHost />
      <Toaster theme="dark" position="top-center" />
    </>
  );
}

export default function App() {
  return (
    <div className="App">
      <PlayerProvider>
        <Shell />
      </PlayerProvider>
    </div>
  );
}
